import React, {Component} from 'react'
import {Nav} from 'react-bootstrap';

import EventEmitter from '../services/EventEmitter';
import {instanceOf} from "prop-types";
import {withTranslation} from 'react-i18next';
import {getCookieValueOrElse, setCookies, setCookieValue} from "../services/CookiesUtils";
import {Cookies, withCookies} from "react-cookie";
import { MdAdminPanelSettings } from "react-icons/md";

const COOKIE_ADMIN_TABS_KEY = "admin-tabs-key";

const ADMIN_ENTRIES = {
    "home": "Accueil",
    "sync": "Synchronisation",
    "listings": "Articles",
    "sections": "Sections",
    "livraison": "Livraison",
    "promo": "Codes promo",
    "commands": "Commandes",
    "account": "Comptes",
    "medias": "Medias",
    "backups": "Backups"
}

export default withCookies(withTranslation('common')(class CAdminNav extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };

    constructor(props) {
        super(props);
        setCookies(props.cookies);
        this.state = {
            section: getCookieValueOrElse(COOKIE_ADMIN_TABS_KEY, "sync"),
        }
    }

    adminMenu(section) {
        this.setState({section}, () => {
            EventEmitter.emitAdminMenu(section);
            setCookieValue(COOKIE_ADMIN_TABS_KEY, section);
        });
    }

    render() {
        // const { t } = this.props;
        // const lang = ApiV0.getLang();
        const activeKey = this.state.section;
        return (
            <Nav defaultActiveKey={activeKey} className="navAdmin">
                <Nav className="me-auto"></Nav>
                <Nav.Link disabled className="noLink" title={"menu admin."}>
                    <b>Admin</b> <MdAdminPanelSettings /></Nav.Link>
                {Object.keys(ADMIN_ENTRIES).map((section, key) => {
                    const title = ADMIN_ENTRIES[section];
                    return (
                        <Nav.Link onClick={this.adminMenu.bind(this, section)} eventKey={section} className="cMenuEntry"
                                  key={key}>
                            {title}
                        </Nav.Link>)
                })}
            </Nav>
        )
    }
}));